const { CarouselElement } = window.BAO.Carousel
const { setInitialised, useArrows } = window.BAO.Carousel.plugins

export class CollectionNavigation extends CarouselElement {
  static get requiredElements () {
    return ['slider', 'slide']
  }

  async connectedCallback () {
    await super.connectedCallback()

    const { maxIdx, slidesLength } = this.carousel.track.details
    if (maxIdx === 0 && slidesLength > 1) {
      this.carousel.update()
    }
  }

  /** @returns {KeenSliderOptions} */
  get options () {
    return {
      slides: {
        perView: 'auto',
        spacing: 10,
      },
      breakpoints: {
        '(min-width: 901px)': {
          slides: {
            perView: 'auto',
            spacing: 30,
          },
        },
      },
    }
  }

  /** @returns {KeenSliderPlugin[]} */
  get plugins () {
    return [
      setInitialised(),
      useArrows({
        next: this.els.next.element,
        previous: this.els.previous.element,
      }),
    ]
  }
}

if (!customElements.get('collection-navigation')) {
  customElements.define('collection-navigation', CollectionNavigation)
}
